import cn from '../../../utils/cn';

// Styles
import styles from './PageHeader.module.css';

/**
 * Page header wrapper component
 * @param {object} props
 * @param {React.ReactNode} props.children - Header content
 * @param {string} [props.className] - Additional CSS classes
 * @param {boolean} [props.isSticky] - Whether the header is sticky
 * @returns {React.ReactNode}
 */
function PageHeader({ isSticky = false, children, className = '' }) {
  return (
    <header
      id="page-header"
      className={cn([
        styles['page-header'],
        isSticky && styles['page-header-sticky'],
        className,
      ])}
    >
      {children}
    </header>
  );
}

/**
 * Page header group component
 * @param {object} props
 * @param {React.ReactNode} props.children - Group content
 * @param {string} [props.className] - Additional CSS classes
 * @returns {React.ReactNode}
 */
export function PageHeaderGroup({ children, className = '' }) {
  return (
    <div className={`${styles['page-header-group']} ${className}`}>
      {children}
    </div>
  );
}

export default PageHeader;
